import React, {useEffect, useState} from "react";

import './Vital.alert.scss';
import Select from "../../forms/inputs/Select";
import Input from "../../forms/inputs/Input";
import Checkbox from "../../forms/inputs/Checkboxk";
import ButtonIcon from "../../forms/buttons/Button.icon";

function VitalEscalationItem({ index, item, onChange, onRemove }) {
    const [timeType, setTimeType] = useState('hrs');

    const timeOptions = [
        {
            label: 'hrs.',
            value: 'hrs'
        }
    ]
    const notificationTypeOptions = [
        {
            label: 'email',
            value: 'email'
        },
        {
            label: 'sms',
            value: 'sms'
        }
    ]
    const notificationRoleOptions = [
        {
            label: 'On call',
            value: 'onCall'
        },
        {
            label: 'Supervisor',
            value: 'supervisor'
        },
        {
            label: 'Call center',
            value: 'callcenter'
        }
    ]

    const getValue = (v, min, max) => {
        let val = '';
        if (v) {
            if (!isNaN(parseInt(v))) {
                val = parseInt(v);
                if (val > max && max !== -1) {
                    val = max;
                }
                if (val < min) {
                    val = min;
                }
                val = '' + val;
            }
        }
        return val;
    }

    const onChangeTimeType = (v) => {
        setTimeType(v);
    }

    const onChangeTime = (v) => {
        item.time = getValue(v, 0, -1);;
        onChange(index, item);
    }

    const onChangeNotification = (v) => {
        item.actionsToTake.action = v;
        onChange(index, item);
    }

    const onChangeRole = (v) => {
        item.actionsToTake.whom = v;
        onChange(index, item);
    }

    return (
        <div className="escalationItem">
            <div>
                <div className="row _time __selectMedium">
                    <Input value={item.time} onChange={onChangeTime} type="number" min={0}/>
                    <Select required={false} value={timeType} onChange={onChangeTimeType} placeholder="--"  options={timeOptions}/>
                </div>
                <p className="row">
                    from alert being triggered, if alert has not been acknoledge by <br/>
                    <b>Selected role above</b> in te Cherish Health Command Center, send a notification
                </p>
                <div className="row _notification">
                    <Select required={false} value={item.actionsToTake.action} onChange={onChangeNotification} placeholder="Notification type..."  options={notificationTypeOptions}/>
                    <Select required={false} value={item.actionsToTake.whom} onChange={onChangeRole} placeholder="Select role..."  options={notificationRoleOptions}/>
                </div>
            </div>
            {
                index !== 0? <i className="material-icons _iconClose" onClick={onRemove}>close</i> : ''
            }
        </div>
    )
}

function VitalEscalation({items, onChange}) {
    const _items = items? items : [];
    useEffect(() => {
        if (!!items && _items.length === 0) {
            add();
        }
    }, [items])

    const add = () => {
        _items.push({
            time: '',
            actionsToTake: {
                action: '',
                whom: ''
            }
        });
        onChange(JSON.parse(JSON.stringify(_items)));
    }

    const _onChange = (index, v) => {
        _items[index] = v;
        onChange(JSON.parse(JSON.stringify(_items)));
    }

    const remove = (i) => {
        return () => {
            _items.splice(i, 1);
            onChange(JSON.parse(JSON.stringify(_items)));
        }
    }

    return (
        <div className="escalationContainer">
            <div className="items">
                {
                    _items.map((item, i) => (
                        <VitalEscalationItem key={i} index={i} item={item} onChange={_onChange} onRemove={remove(i)}/>
                    ))
                }
            </div>
            <div className="actionButton" onClick={add}>
                <ButtonIcon size={34}>
                    <span className="material-icons">
                        add
                        </span>
                </ButtonIcon>
                <p>Add another escalation</p>
            </div>
        </div>
    )
}

function VitalAlert({ alertType, vital, units, dataFields, clinicianOptions }) {
    const getTriggerAlerts = () => {
        let enableHigh, enableLow;
        if (alertType === 'sustained') {
            enableHigh = ['HR', 'RR', 'Temp'];
            enableLow = ['W', 'BP', 'HR', 'RR', 'Temp', 'SPO2'];
        } else {
            enableHigh = ['HR', 'Temp'];
            enableLow = ['HR', 'RR', 'Temp', 'SPO2'];
        }
        const high = vital && enableHigh.includes(vital);
        const low = vital && enableLow.includes(vital);
        return {
            high: high,
            low: low
        }
    }

    const maxCondOptions = [
        {
            label: '≥',
            value: '≥'
        },
        {
            label: '>',
            value: '>'
        }
    ]

    const minCondOptions = [
        {
            label: '≤',
            value: '≤'
        },
        {
            label: '<',
            value: '<'
        }
    ]

    const timeOptions = [
        {
            label: 'mins',
            value: 'mins'
        }
    ]

    const minVal = 0;
    const maxVal = -1;
    const maxMin = 45;
    const minMin = 0;

    const getValue = (v, min, max) => {
        let val = '';
        if (v) {
            if (!isNaN(parseInt(v))) {
                val = parseInt(v);
                if (val > max && max !== -1) {
                    val = max;
                }
                if (val < min) {
                    val = min;
                }
                val = '' + val;
            }
        }
        return val;
    }
    const onChangeHighValue = (v) => {
        dataFields['high_value'].onChange(getValue(v, minVal, maxVal));
    }
    const onChangeLowValue = (v) => {
        dataFields['low_value'].onChange(getValue(v, minVal, maxVal));
    }
    const onChangeHighTime = (v) => {
        dataFields['high_time'].onChange(getValue(v, minMin, maxMin));
    }
    const onChangeLowTime = (v) => {
        dataFields['low_time'].onChange(getValue(v, minMin, maxMin));
    }

    return (
        <div className="containerAlert">
             <div className="row">
                 <span className="label _gray">Trigger and alert if</span>
             </div>
             {
                 getTriggerAlerts().high?
                    <div className="row _col7">
                        <Checkbox label="HIGH" onChange={dataFields['check_high'].onChange} bool={dataFields['check_high'].value} />
                        <Select required={false} placeholder="--" value={dataFields['high_condition'].value} onChange={dataFields['high_condition'].onChange} options={maxCondOptions}/>
                        <Input value={dataFields['high_value'].value} onChange={onChangeHighValue} min={minVal} type="number"/>
                        <span className="label">% of predicted maximal</span>
                        <span className="label">for</span>
                        <Input value={dataFields['high_time'].value} onChange={onChangeHighTime} min={minMin} max={maxMin} type="number"/>
                        <Select required={false} placeholder="--" value={dataFields['high_time_condition'].value} onChange={dataFields['high_time_condition'].onChange} options={timeOptions}/>
                    </div> : ''
             }
             {
                 getTriggerAlerts().low?
                    <div className="row _col7">
                        <Checkbox label="LOW" onChange={dataFields['check_low'].onChange} bool={dataFields['check_low'].value} />
                        <Select required={false} placeholder="--" value={dataFields['low_condition'].value} onChange={dataFields['low_condition'].onChange} options={minCondOptions}/>
                        <Input value={dataFields['low_value'].value} onChange={onChangeLowValue} min={minVal} type="number"/>
                        <span className="label">{units}</span>
                        <span className="label">for</span>
                        <Input value={dataFields['low_time'].value} onChange={onChangeLowTime} min={minMin} max={maxMin} type="number"/>
                        <Select required={false} placeholder="--" value={dataFields['low_time_condition'].value} onChange={dataFields['low_time_condition'].onChange} options={timeOptions}/>
                    </div> : ''
             }
             <div className="row">
                 <h4>Notifications</h4>
                 <span className="label _start">A notification will be displayed in the command center</span>
             </div>
            <div className="row _fullWidth __selectMedium">
                <Checkbox label="Acknowledge notifications" onChange={dataFields['check_acknowledge_notification'].onChange} bool={dataFields['check_acknowledge_notification'].value} />
                <div className="__selectMedium">
                    <Select required={false} placeholder="Select role..." value={dataFields['acknowledge_notification'].value} onChange={dataFields['acknowledge_notification'].onChange} options={clinicianOptions}/>
                    <p>
                        daily asynchronous in the Cherish Health Command Center
                    </p>
                    <div className="divider">
                    </div>
                </div>
            </div>
             <div className="row">
                 <Checkbox label="Escalation" onChange={dataFields['check_escalations'].onChange} bool={dataFields['check_escalations'].value} />
                 <VitalEscalation items={dataFields['escalations'].value} onChange={dataFields['escalations'].onChange} />
             </div>
             <div className="divider">
             </div>
             <div className="row __selectMedium">
                 <Checkbox label="Daily summary email" onChange={dataFields['check_daily_summary'].onChange} bool={dataFields['check_daily_summary'].value} />
                 <div>
                     <p>Subscribe to a daily summary of the day´s events</p>
                     <Select required={false} placeholder="Select role..." value={dataFields['daily_summary_email'].value} onChange={dataFields['daily_summary_email'].onChange} options={clinicianOptions}/>
                 </div>
             </div>
            <div className="divider">
            </div>
        </div>
    )
}

export default VitalAlert;